module.exports = __webpack_public_path__ + "img/thank-you-test.0f797b3a.svg";